import { useEffect, useState } from 'react';
import { getCategories } from '../api/categories.api';
import type { Category } from '../types/category.type';

// ✅ Import centralized types instead of defining here
// This ensures consistency across the entire app

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await getCategories();

        // ✅ NORMALIZE AT THE BOUNDARY
        const payload: Category[] = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];

        setCategories(payload);
      } catch (err) {
        console.error('❌ Categories API error:', err);
        setError('Failed to load categories');
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
};